"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseICalendarItemDataEntity = void 0;
const icalendar_event_1 = require("./icalendar-event");
function parseICalendarItemDataEntity(data) {
    if (typeof data.calendarEventDeletedTime === 'string')
        data.calendarEventDeletedTime = new Date(data.calendarEventDeletedTime);
    if (typeof data.calendarSyncAttemptTime === 'string')
        data.calendarSyncAttemptTime = new Date(data.calendarSyncAttemptTime);
    if (data.calendarEvent !== null && typeof data.calendarEvent === 'object')
        data.calendarEvent = (0, icalendar_event_1.parseICalendarEvent)(data.calendarEvent);
    return data;
}
exports.parseICalendarItemDataEntity = parseICalendarItemDataEntity;
